import React from 'react'

import classnames from 'classnames'

import css from './OrderConfirmationHeader.css'

type Props = {
  canEditOrder: boolean
  deliveryDate: string
  deliveryStart: string
  deliveryEnd: string
  whenCutoffTime: string
  whenCutoffDate: string
}

const OrderConfirmationHeader = ({
  canEditOrder,
  deliveryDate,
  deliveryStart,
  deliveryEnd,
  whenCutoffTime,
  whenCutoffDate,
}: Props) => (
  <div data-testing="orderConfirmationHeader">
    <p className={css.paragraph}>
      Delivery date: {deliveryDate}
      {', '}
      between {deliveryStart} and {deliveryEnd}
    </p>
    <p className={classnames(css.paragraph, css.bold)}>
      {canEditOrder
        ? `You can edit your choices until ${whenCutoffTime} on ${whenCutoffDate}`
        : `You can no longer edit your choices as editing closed at ${whenCutoffTime} on ${whenCutoffDate}`}
    </p>
  </div>
)

export { OrderConfirmationHeader }
